import { render } from "./Item-discount.vue?vue&type=template&id=0370ae8a&scoped=true"
import script from "./Item-discount.vue?vue&type=script&lang=js"
export * from "./Item-discount.vue?vue&type=script&lang=js"

import "./Item-discount.vue?vue&type=style&index=0&id=0370ae8a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0370ae8a"]])

export default __exports__